import AllRouter from "./routes/AllRouter";

function App() {
  return <AllRouter />;
}

export default App;
